<div class="vertage-announcement z-1 relative bg-primary p-3 flex justify-content-center align-items-center text-center">
    <span class="line-height-3">{{ text }}</span>
</div>
